// Imports
import { Link } from "@octopus-investments/deep-sea-components";

// Responsiveness
export const BREAKPOINTS = Object.freeze({ mobile: 501, tablet: 1104 });

// Error messages
export const VALIDATION_ERRORS = Object.freeze({
  emailExists: "This email is already associated with an Octopus Investments account.",
  emptyField: "Please enter your email first",
  passwordMatch: "Please make sure both passwords match.",
  accountNumberNotFound: "Sorry, we can't find your account. Please double-check your details, or ",
  accountNumberExists:
    "Sorry, that account number is already registered with a different email address. Please double-check your details, or ",
  wrongCode:
    "The code you entered doesn’t match what’s shown in the authenticator or passwords app, or it may have expired. The code refreshes every 30–60 seconds. Please try again.",
  wrongPattern:
    "Sorry, that email address doesn’t look right. Please provide a valid email address.",
});

export const SYSTEM_ERRORS = Object.freeze({
  424: "Sorry, we're experiencing issues with our email service. Please try again later, or reach out to us using the blue button located in the bottom right corner of your screen.",
});

// MFA tooltip

export const MFA_AUTH_CODE_TOOLTIP =
  "Open your chosen authentication app on your mobile device. Your 6 digit code can be found there";

// Phone numbers
export const ADVISER_PHONE = (
  <Link isInline href="tel:08003162067">
    0800 316 2067
  </Link>
);

export const INVESTOR_PHONE = (
  <Link isInline href="tel:08003162295">
    0800 316 2295
  </Link>
);
